//入库数据类型
export const DateBaseTypeList = ['基础地理参考数据', '实验验证数据', '遥感应用特征数据', '信息产品数据', '模型算法', '数据产品', '信息服务数据']
//入库基础地理参考数据类型
export const BasicGeoType = [{
  value: '矢量数据',
  label: '矢量数据'
},
{
  value: '高程数据',
  label: '高程数据'
},
{
  value: '几何产品检验基准数据',
  label: '几何产品检验基准数据'
},
{
  value: '遥感图像辐射基准数据',
  label: '遥感图像辐射基准数据'
}]
//入库实验验证数据类型
export const ExperimentalType = [{
  value: '站点几何参数数据',
  label: '站点几何参数数据'
},
{
  value: '实验现场三维成像测量数据',
  label: '实验现场三维成像测量数据'
},
{
  value: '实验现场卫星同步观测数据',
  label: '矢量实验现场卫星同步观测数据数据'
},
{
  value: '实验现场航空同步观测数据',
  label: '实验现场航空同步观测数据'
},
{
  value: '几何类产品质检数据',
  label: '几何类产品质检数据'
},
{
  value: '辐射类产品质检数据',
  label: '辐射类产品质检数据'
},
{
  value: '陆表类产品质检数据',
  label: '陆表类产品质检数据'
},
{
  value: '植被类产品质检数据',
  label: '植被类产品质检数据'
},
{
  value: '大气类产品质检数据',
  label: '大气类产品质检数据'
},
{
  value: '水体类产品质检数据',
  label: '水体类产品质检数据'
},
{
  value: '光学卫星产品生产模块检验数据',
  label: '矢量光学卫星产品生产模块检验数据数据'
},
{
  value: '微波卫星产品生产模块检验数据',
  label: '微波卫星产品生产模块检验数据'
},
{
  value: '综合产品生产模块检验数据',
  label: '综合产品生产模块检验数据'
},
{
  value: '通用工具检验数据',
  label: '通用工具检验数据'
},
{
  value: '产品质量检验成果',
  label: '产品质量检验成果'
},
{
  value: '模块流程检验成果',
  label: '模块流程检验成果'
},]
//入库遥感应用特征数据类型
export const RemoteSensingFeatureType = [{
  value: '典型地物光谱特征数据',
  label: '典型地物光谱特征数据'
},
{
  value: '典型地物纹理特征数据',
  label: '典型地物纹理特征数据'
},
{
  value: '典型目标几何特征数据',
  label: '典型目标几何特征数据'
},
{
  value: '水体遥感特征数据',
  label: '水体遥感特征数据'
},
{
  value: '大气遥感特征数据',
  label: '大气遥感特征数据'
},
{
  value: '中国区域多尺度样本数据',
  label: '中国区域多尺度样本数据'
},
{
  value: '中国区域光谱特征信息数据',
  label: '中国区域光谱特征信息数据'
},
{
  value: '中国区域时谱特征信息数据',
  label: '中国区域时谱特征信息数据'
},
{
  value: '中国区域图谱特征信息数据',
  label: '中国区域图谱特征信息数据'
}]
//入库信息产品数据类型
export const InformationProductsType = [{
  value: '信息瓦片',
  label: '信息瓦片'
},
{
  value: '产品瓦片',
  label: '产品瓦片'
}]
//入库模型算法类型
export const ModelAlgorithmType = [{
  value: '野外实测数据处理模型',
  label: '野外实测数据处理模型'
},
{
  value: '光学卫星数据预处理模型',
  label: '光学卫星数据预处理模型'
},
{
  value: '微波卫星数据预处理模型',
  label: '微波卫星数据预处理模型'
},
{
  value: '通用数据处理模型',
  label: '通用数据处理模型'
},
{
  value: '光学卫星数据仿真模型',
  label: '光学卫星数据仿真模型'
},
{
  value: '微波卫星数据仿真模型',
  label: '微波卫星数据仿真模型'
},
{
  value: '光学卫星3-5级产品生产模型',
  label: '光学卫星3-5级产品生产模型'
},
{
  value: '微波卫星3-5级产品生产模型',
  label: '微波卫星3-5级产品生产模型'
},
{
  value: '光学卫星产品生产模块检验模型',
  label: '光学卫星产品生产模块检验模型'
},
{
  value: '微波卫星产品生产模块检验模型',
  label: '微波卫星产品生产模块检验模型'
},
{
  value: '综合产品生产模块检验模型',
  label: '综合产品生产模块检验模型'
},
{
  value: '通用工具检验模型',
  label: '通用工具检验模型'
},
{
  value: '几何类产品质量检验模型',
  label: '几何类产品质量检验模型'
},
{
  value: '辐射类产品质量检验模型',
  label: '辐射类产品质量检验模型'
},
{
  value: '陆表类产品质量检验模型',
  label: '陆表类产品质量检验模型'
},
{
  value: '植被类产品质量检验模型',
  label: '植被类产品质量检验模型'
},
{
  value: '大气类产品质量检验模型',
  label: '大气类产品质量检验模型'
},
{
  value: '水体类产品质量检验模型',
  label: '水体类产品质量检验模型'
},
{
  value: '行业专题产品生产模型',
  label: '行业专题产品生产模型'
},
{
  value: '时空综合信息分析模型',
  label: '时空综合信息分析模型'
}]
//入库数据产品类型
export const DataProductType = [{
  value: '光学卫星数据',
  label: '光学卫星数据'
},
{
  value: '光学卫星仿真数据',
  label: '光学卫星仿真数据'
},
{
  value: '微波卫星仿真数据',
  label: '微波卫星仿真数据'
}]
//入库信息服务数据类型
export const DataService = [{
  value: '文档数据',
  label: '文档数据',
}]

//入库数据接口对照表
export const InterfaceComparison = {
  "矢量数据": 'vectorUpload',
  "高程数据": 'demUpload',
  "几何产品检验基准数据": 'othersUpload',
  "遥感图像辐射基准数据": 'othersUpload',
  "野外实测数据处理模型": 'othersUpload',
  "光学卫星数据预处理模型": 'othersUpload',
  "微波卫星数据预处理模型": 'othersUpload',
  "通用数据处理模型": 'othersUpload',
  "光学卫星数据仿真模型": 'othersUpload',
  "微波卫星数据仿真模型": 'othersUpload',
  "光学卫星3-5级产品生产模型": 'othersUpload',
  "微波卫星3-5级产品生产模型": 'othersUpload',
  "光学卫星产品生产模块检验模型": 'othersUpload',
  "微波卫星产品生产模块检验模型": 'othersUpload',
  "综合产品生产模块检验模型": 'othersUpload',
  "通用工具检验模型": 'othersUpload',
  "几何类产品质量检验模型": 'othersUpload',
  "辐射类产品质量检验模型": 'othersUpload',
  "陆表类产品质量检验模型": 'othersUpload',
  "植被类产品质量检验模型": 'othersUpload',
  "大气类产品质量检验模型": 'othersUpload',
  "水体类产品质量检验模型": 'othersUpload',
  "行业专题产品生产模型": 'othersUpload',
  "时空综合信息分析模型": 'othersUpload',
  "典型地物光谱特征数据": 'othersUpload',
  "典型地物纹理特征数据": 'othersUpload',
  "典型目标几何特征数据": 'othersUpload',
  "水体遥感特征数据": 'othersUpload',
  "大气遥感特征数据": 'othersUpload',
  "中国区域多尺度样本数据": 'othersUpload',
  "中国区域光谱特征信息数据": 'othersUpload',
  "中国区域时谱特征信息数据": 'othersUpload',
  "中国区域图谱特征信息数据": 'othersUpload',
  "站点几何参数数据": 'othersUpload',
  "实验现场三维成像测量数据": 'othersUpload',
  "实验现场卫星同步观测数据": 'othersUpload',
  "实验现场航空同步观测数据": 'othersUpload',
  "几何类产品质检数据": 'othersUpload',
  "辐射类产品质检数据": 'othersUpload',
  "陆表类产品质检数据": 'othersUpload',
  "植被类产品质检数据": 'othersUpload',
  "大气类产品质检数据": 'othersUpload',
  "水体类产品质检数据": 'othersUpload',
  "光学卫星产品生产模块检验数据": 'othersUpload',
  "微波卫星产品生产模块检验数据": 'othersUpload',
  "综合产品生产模块检验数据": 'othersUpload',
  "通用工具检验数据": 'othersUpload',
  "产品质量检验成果": 'prodDocumentUpload',
  "模块流程检验成果": 'prodDocumentUpload',
  "光学卫星数据": 'othersUpload',
  "光学卫星仿真数据": 'othersUpload',
  "微波卫星仿真数据": 'othersUpload',
  "信息瓦片": 'othersUpload',
  "产品瓦片": 'othersUpload',
  "文档数据": 'prodDocumentUpload',
}